import { Button, Input } from 'reactstrap';
import './TableFooter.scss';

interface Props {
  pageCount: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  currentPage: number;
  handleMovePage: (page: number) => void;
  handleChangeCurrentPage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleKeyUpPage: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const TableFooter = (props: Props) => {
  const {
    pageCount,
    canPreviousPage,
    canNextPage,
    currentPage,
    handleMovePage,
    handleChangeCurrentPage,
    handleKeyUpPage,
  } = props;

  return pageCount > 1 ? (
    <div className='pagination align-items-center mt-2 py-2'>
      <div className='d-flex align-items-center'>
        <Button size='sm' className='mr-2' onClick={() => handleMovePage(1)} disabled={!canPreviousPage}>
          <i className='fa fa-fast-backward' />
        </Button>
        <Button size='sm' className='m-0' onClick={() => handleMovePage(currentPage - 1)} disabled={!canPreviousPage}>
          <i className='fa fa-caret-left' />
        </Button>
        <span className='ms-4 me-1'>Page</span>{' '}
        <Input
          className='d-inline-block pagination-input text-center rounded-1'
          name='currentPage'
          value={currentPage}
          onChange={handleChangeCurrentPage}
          onKeyUp={handleKeyUpPage}
          onBlur={() => handleMovePage(currentPage)}
        />{' '}
        <span className='ms-1 me-4'>of {pageCount}</span>
        <Button size='sm' className='m-0' onClick={() => handleMovePage(currentPage + 1)} disabled={!canNextPage}>
          <i className='fa fa-caret-right' />
        </Button>
        <Button size='sm' className='ml-2' onClick={() => handleMovePage(pageCount)} disabled={!canNextPage}>
          <i className='fa fa-fast-forward' />
        </Button>
      </div>
    </div>
  ) : null;
};
